import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'app/shared/services/company.service';
import { Company } from 'app/shared/models/company';

@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.css']
})
export class CompaniesListComponent implements OnInit {

  public Companies:Company[];
  constructor(private companyService:CompanyService) { }

  ngOnInit() {
    this.companyService.getCompanies().then((companies) => {
      this.Companies = companies;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/companies-admin/companies-list/companies-list.component.ts